"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var propertySizeBuilder = function propertySizeBuilder(params, context) {
  if (context === null || context === void 0 ? void 0 : context.withoutPropertySize) {
    return '';
  }

  var sizeMinFilter = params.sizeMin ? "propertySize>=" + params.sizeMin : '';
  var sizeMaxFilter = params.sizeMax ? "propertySize<=" + params.sizeMax : '';
  return [sizeMinFilter, sizeMaxFilter].filter(Boolean).join(' AND ');
};

var _default = propertySizeBuilder;
exports["default"] = _default;